import type { SelectionPluginOptions } from '@atlaskit/editor-common/selection';

interface Props {
	// The type is `Pick<SelectionPluginOptions, never>`
	// because we need the `__livePage` property that is not a part of `SelectionPluginOptions`.
	// When `__livePage` is removed, replace this with `never`.
	options: Pick<SelectionPluginOptions, never>;
}

export function selectionPluginOptions({ options }: Props): SelectionPluginOptions {
	return {
		useLongPressSelection: false,
		// @ts-ignore Temporary solution to check for Live Page editor.
		__livePage: options.__livePage,
	};
}
